<template>
  <div class="">
    <vue-headful :title="doctitle" />
    <div class="background tickets">
      <div class="container">
        <div class="row pt-5">
          <div class="col-md-12 pt-5">
            <div class="glitch">
              <div class="line hero-headline">
                Øredev Developer Conference <br />8-10 Nov, Sweden
              </div>
            </div>
          </div>
        </div>
        <b-row no-gutters class="mt-xl-5 mt-1 pb-lg-5">
          <b-col cols="12" md="8">
            <div
              class="pass-container mt-5 mt-md-0 mr-1 mr-sm-0 ml-1 ml-sm-0 pb-3 pb-md-5"
            >
              <div class="price-info">
                The prices are in swedish crown (SEK) and exclusive of V.A.T
              </div>

              <div class="workshop-info ml-0 pl-0 pl-md-1 ml-md-3 mt-3">
                Conference tickets are not needed for you to attend the
                workshops.
              </div>

              <div class="pass mt-5 mb-5 mb-md-0">
                <div class="desc w-100">
                  <b-row>
                    <b-col cols="9">
                      <h5>
                        Dennis van der Stelt - Event Driven Microservices in
                        Vertical Slices
                      </h5>
                      <p class="date">Tuesday, Nov 7th at 9am</p>
                      <p>Workshop ticket price: 1200 SEK</p>
                    </b-col>
                    <b-col cols="3">
                      <a
                        href="https://www.trippus.se/web/registration/Registration.aspx?view=registration&idcategory=AB0ILBBpqy4cq4gfwx7S-0Ef1Kl6Zc84w9OkHtXIHdDz4rtjwNvXGs_RdrpJm6q11yNkiRq2X9gm&ln=eng"
                        target="_blank"
                        rel="noopener noreferrer"
                        ><b-button
                          class="buy-button float-right btn-1 btn-1-dark"
                          >Buy</b-button
                        ></a
                      ></b-col
                    >
                  </b-row>
                </div>
              </div>

              <div class="pass mb-5 mb-md-0">
                <div class="desc w-100">
                  <b-row>
                    <b-col cols="9">
                      <h5>
                        Olle E Johansson - First Steps Towards Securing Your
                        Software Supply Chain in the Lights of the Cyber
                        Resilience Act
                      </h5>
                      <p class="date">Tuesday, Nov 7th at 10:45am</p>
                      <p>Workshop ticket price: 1200 SEK</p>
                    </b-col>
                    <b-col cols="3">
                      <a
                        href="https://www.trippus.se/web/registration/Registration.aspx?view=registration&idcategory=AB0ILBBpqy4cq4gfwx7S-0Ef1Kl6Zc84w9OkHtXIHdDz4rtjwNvXGs_RdrpJm6q11yNkiRq2X9gm&ln=eng"
                        target="_blank"
                        rel="noopener noreferrer"
                        ><b-button
                          class="buy-button float-right btn-1 btn-1-dark"
                          >Buy</b-button
                        ></a
                      ></b-col
                    >
                  </b-row>
                </div>
              </div>

              <div class="pass">
                <div class="desc w-100">
                  <b-row>
                    <b-col cols="9">
                      <h5 class="w-full">
                        Anton Kulaga - Hack Your Own Genome
                      </h5>
                      <p class="date">Tuesday, Nov 7th at 1pm</p>
                      <p>Workshop ticket price: 1200 SEK</p>
                    </b-col>
                    <b-col cols="3">
                      <a
                        href="https://www.trippus.se/web/registration/Registration.aspx?view=registration&idcategory=AB0ILBBpqy4cq4gfwx7S-0Ef1Kl6Zc84w9OkHtXIHdDz4rtjwNvXGs_RdrpJm6q11yNkiRq2X9gm&ln=eng"
                        target="_blank"
                        rel="noopener noreferrer"
                        ><b-button
                          class="buy-button float-right btn-1 btn-1-dark"
                          >Buy</b-button
                        ></a
                      ></b-col
                    >
                  </b-row>
                </div>
              </div>

              <div class="pass mb-5 mb-md-0">
                <div class="desc w-100">
                  <b-row>
                    <b-col cols="9">
                      <h5>
                        Emily Bache - Introduction to Approval Testing: Get Your
                        Legacy Code Under Control
                      </h5>
                      <p class="date">Tuesday, Nov 7th at 1pm</p>
                      <p>Workshop ticket price: 1200 SEK</p>
                    </b-col>
                    <b-col cols="3">
                      <a
                        href="https://www.trippus.se/web/registration/Registration.aspx?view=registration&idcategory=AB0ILBBpqy4cq4gfwx7S-0Ef1Kl6Zc84w9OkHtXIHdDz4rtjwNvXGs_RdrpJm6q11yNkiRq2X9gm&ln=eng"
                        target="_blank"
                        rel="noopener noreferrer"
                        ><b-button
                          class="buy-button float-right btn-1 btn-1-dark"
                          >Buy</b-button
                        ></a
                      ></b-col
                    >
                  </b-row>
                </div>
              </div>

              <div class="pass mb-5 mb-md-0">
                <div class="desc w-100">
                  <b-row>
                    <b-col cols="9">
                      <h5>Rami Krispin - Forecasting With Linear Regression</h5>
                      <p class="date">Tuesday, Nov 7th at 2:45pm</p>
                      <p>Workshop ticket price: 1200 SEK</p>
                    </b-col>
                    <b-col cols="3">
                      <a
                        href="https://www.trippus.se/web/registration/Registration.aspx?view=registration&idcategory=AB0ILBBpqy4cq4gfwx7S-0Ef1Kl6Zc84w9OkHtXIHdDz4rtjwNvXGs_RdrpJm6q11yNkiRq2X9gm&ln=eng"
                        target="_blank"
                        rel="noopener noreferrer"
                        ><b-button
                          class="buy-button float-right btn-1 btn-1-dark"
                          >Buy</b-button
                        ></a
                      ></b-col
                    >
                  </b-row>
                </div>
              </div>
              <div class="pass mb-5 mb-md-0">
                <div class="desc w-100">
                  <b-row>
                    <b-col cols="9">
                      <h5>
                        Tariq King - Breaking Into AI and Machine Learning
                      </h5>
                      <p class="date">Friday, Nov 10th at 1:30pm</p>
                      <p>Workshop ticket price: 1200 SEK</p>
                    </b-col>
                    <b-col cols="3">
                      <a
                        href="https://www.trippus.se/web/registration/Registration.aspx?view=registration&idcategory=AB0ILBBpqy4cq4gfwx7S-0Ef1Kl6Zc84w9OkHtXIHdDz4rtjwNvXGs_RdrpJm6q11yNkiRq2X9gm&ln=eng"
                        target="_blank"
                        rel="noopener noreferrer"
                        ><b-button
                          class="buy-button float-right btn-1 btn-1-dark"
                          >Buy</b-button
                        ></a
                      ></b-col
                    >
                  </b-row>
                </div>
              </div>

              <div class="pass mb-5 mb-md-0">
                <div class="desc w-100">
                  <b-row>
                    <b-col cols="9">
                      <h5>
                        Krzysztof Slowinski - Engineering Scalable IaC Solutions
                        to Overcome Cloud Limits
                      </h5>
                      <p class="date">Friday, Nov 10th at 3:15pm</p>
                      <p>Workshop ticket price: 1200 SEK</p>
                    </b-col>
                    <b-col cols="3">
                      <a
                        href="https://www.trippus.se/web/registration/Registration.aspx?view=registration&idcategory=AB0ILBBpqy4cq4gfwx7S-0Ef1Kl6Zc84w9OkHtXIHdDz4rtjwNvXGs_RdrpJm6q11yNkiRq2X9gm&ln=eng"
                        target="_blank"
                        rel="noopener noreferrer"
                        ><b-button
                          class="buy-button float-right btn-1 btn-1-dark"
                          >Buy</b-button
                        ></a
                      ></b-col
                    >
                  </b-row>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <WorkshopSpeakers />

    <div class="pt-5">
      <b-container>
        <b-row no-gutters>
          <b-col md="6" cols="12">
            <h1 class="mt-5 text-dark">How does it work?</h1>

            <p class="mt-4">
              This year, all the workshops at Øredev are avalable to everyone:
              you don’t need to have a ticket to Øredev in order to register for
              any of the workshops! All workshops have a flat fee and you can
              register for as many as you want!
            </p>
            <p>
              The workshops offered in 2023 have a time slot of 90 minutes and
              have a minimum of 15 attendees; If a workshop doesn't reach
              minimum attendance, it'll be canceled and you will receive a
              refund. (No-shows will NOT qualify for a refund!).
            </p>
            <p>
              The workshops will take place at a DIFFERENT venue and are not
              scheduled in parallel with any of the talks during Øredev 2023.
              When you register, you’ll receive all the practical information
              needed in order to participate!
            </p>
            <p class="pb-0 pb-md-5">
              Questions? We’re here for you:
              <a href="mailto:info@oredev.org">info@oredev.org</a>
            </p>
          </b-col>
          <b-col
            md="6"
            cols="12"
            class="d-flex align-items-center justify-content-center mt-4 mt-md-0 mb-5 mb-md-0"
          >
            <b-img
              id="book-1"
              class="d-none d-xl-block mr-0 mr-md-n5 ml-0 ml-5"
              fluid
              src="https://res.cloudinary.com/oredev/image/upload/v1687168588/2023_web/workshops/people.png"
            />
            <div class="d-flex align-items-center h-100">
              <b-img
                id="book-2"
                class="d-block d-xl-none"
                fluid
                src="https://res.cloudinary.com/oredev/image/upload/v1687168588/2023_web/workshops/people.png"
              />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="venue pb-5 bg-color-dark text-light position-relative">
      <b-container class="pt-5">
        <b-row>
          <b-col xl="1"></b-col>
          <b-col>
            <b-container>
              <b-row>
                <b-col md="6" class="info left">
                  <div class="text-center">
                    <b-img
                      class="icons pb-3"
                      src="https://res.cloudinary.com/oredev/image/upload/v1648207784/2022_web/Pin_oaojsf.svg"
                    ></b-img>
                  </div>
                  <div class="info-background">
                    <h5 class="text-light info-headline">
                      The venue: Devoteam Creative Tech office in Malmö
                    </h5>

                    <p>
                      Hans Michelsensgatan 10, 211 20 Malmö, Sweden The venue is
                      at the modern Devoteam office which is the Workshop Hub
                      for Øredev 2023! It's located just behind Malmö C central
                      station.
                    </p>
                  </div>
                </b-col>
                <b-col md="6" class="info right">
                  <div class="text-center">
                    <b-img
                      class="icons pb-3"
                      src="https://res.cloudinary.com/oredev/image/upload/v1648207788/2022_web/Train_wxfrny.svg"
                    ></b-img>
                  </div>
                  <div class="info-background">
                    <h5 class="text-light info-headline">
                      Join us by train or buss
                    </h5>
                    <p>
                      It’s easy to get to Øredev by train, the venue is located
                      only a short walking distance away from Hyllie station,
                      the first stop in Sweden after Copenhagen Airport.
                    </p>
                    <p>
                      If you are on a budget and coming from Sweden, Denmark or
                      North Germany, you can check with
                      <a href="https://www.flixbus.se/" target="_blank"
                        >Flixbuss</a
                      >.
                    </p>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-md-5">
                <b-col md="6" class="info left">
                  <div class="text-center">
                    <b-img
                      class="icons pb-3"
                      src="https://res.cloudinary.com/oredev/image/upload/v1648207762/2022_web/airplane_za7cip.svg"
                    ></b-img>
                  </div>
                  <div class="info-background">
                    <h5 class="text-light info-headline">Join us by air</h5>
                    <p>
                      Copenhagen Airport is connected to Malmö by the Øresund
                      Bridge.
                    </p>
                    <p>
                      Take the train from the airport and 30 minutes later you
                      will find yourself in Malmö C and a 5 minutes walk to the
                      venue.
                    </p>
                  </div>
                </b-col>
                <b-col md="6" class="info right">
                  <div class="text-center">
                    <b-img
                      class="icons pb-3"
                      src="https://res.cloudinary.com/oredev/image/upload/v1648207766/2022_web/Car_lx3pdc.svg"
                    ></b-img>
                  </div>
                  <div class="info-background">
                    <h5 class="text-light info-headline">Join us by car</h5>
                    <p>There are plenty of parking places around the venue.</p>
                  </div>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
          <b-col xl="1"></b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import WorkshopSpeakers from "../components/WorkshopSpeakers.vue";
import SvgFood from "../components/Svg/SvgFood.vue";

export default {
  name: "workshops",
  components: {
    SvgFood,
    WorkshopSpeakers,
  },
  data() {
    return {
      doctitle: "Tickets - " + this.$store.state.conferencename,
      startEffect: false,
    };
  },
  methods: {},
  mounted: function () {
    setTimeout(() => {
      this.startEffect = true;
    }, 1500);
  },
};
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/variables.scss";

.info-headline {
  font-family: "Outfit";
  font-style: normal;
  font-weight: 800;
}

h5 {
  font-family: Outfit, Geneva, Tahoma, sans-serif;
}

#book-1 {
  z-index: 99;
}

#book-2 {
  z-index: 99;
}

.qoute-symbol-yellow {
  background: url(https://res.cloudinary.com/oredev/image/upload/v1648207768/2022_web/citat_tecken_gul_k1ohnz.svg);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 110px;
}
.qoute-symbol-green {
  background: url(https://res.cloudinary.com/oredev/image/upload/v1648207767/2022_web/citat_tecken_gro%CC%88n_fykb3d.svg);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 110px;
}
.icons {
  width: 10rem;
  @media (max-width: 567px) {
    width: 14rem !important;
    top: 480%;
    left: 40%;
  }
}

.convince-boss-button {
  box-shadow: 5px 5px #81cc00;
  padding: 10px;
  border: 0;
  border-radius: 0;
  background-color: #7140c4;
}

.reason-number {
  font-size: 6rem;
  @media (max-width: 567px) {
    left: 40%;
    top: -80%;
    font-size: 5rem !important;
  }
}

.star {
  color: $green;
}
.pass-container {
  margin: 0 0 40px 0;
  background-color: $bg-dark;
  padding: 15px;
}

.tickets .price-info,
.workshop-info {
  text-align: right;
  color: #fff;
  font-style: italic;
  font-size: 0.8rem;
  padding: 5px 10px;
}
.workshop-info {
  font-style: initial;
  text-align: left;
}

.pass {
  background-color: $bg-dark;
  color: white;
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding: 0 0 0 20px;
  width: 100%;
  height: 75px;

  .date {
    font-weight: 700;
    color: #69afab !important;
    margin: 4px 0 !important;
  }

  @media screen and (max-width: 600px) {
    padding: 0;
    margin-top: 70px;
  }

  &:hover {
    color: inherit;

    .price {
      color: #fff;
    }
  }

  &.sold-out {
    color: #000;
    background-color: #ddd;
    cursor: not-allowed;

    .price {
      color: #000;
    }
  }

  .desc {
    h5 {
      font-size: 14px;
      line-height: 1.2rem;
      font-family: Outfit, Geneva, Tahoma, sans-serif;
      color: $text-color-light;
      margin: 0 0 2px 0;
      font-weight: 700 !important;
      @media (max-width: 1000px) {
        font-size: 16px;
      }
      @media (max-width: 450px) {
        font-size: 16px;
      }
    }
    p {
      color: white;
      font-size: 12px !important;
      margin: 0;
    }
  }

  .arrow {
    float: right;
    color: $green;
    margin: 0;
    height: 75px;
    padding: 15px 2px 0 2px;
    @media (max-width: 991px) {
      width: 10%;
    }

    i {
      font-size: 45px;
      @media (max-width: 567px) {
        font-size: 1.6rem;
        line-height: 1.6;
      }
    }
  }

  .price {
    font-size: 1rem;
    width: 20%;
    padding: 24px 0 0 0;
    margin: 0;
    height: 100%;
    font-weight: bold;
    text-align: right;
    color: #000;
    @media (max-width: 567px) {
      font-size: 0.8rem;
    }
    @media (max-width: 450px) {
      padding-top: 29px;
      font-size: 0.6rem;
    }
  }
}

h3 {
  color: #fff;
}

.venue .info.left {
  padding: 0 30px 0 0;
  @media (max-width: 767px) {
    padding: 0 0 0 0;
  }
}
.venue .info.right {
  padding: 0 0 0 30px;
  @media (max-width: 767px) {
    padding: 0 0 0 0;
  }
}

@keyframes move4 {
  0% {
    transform: translate(5px, 2px);
    animation-timing-function: ease-in-out;
  }
  25% {
    transform: translate(4px, 4px);
    animation-timing-function: ease-in-out;
  }

  50% {
    transform: translate(2px, 3px);
    animation-timing-function: ease-in-out;
  }
  75% {
    transform: translate(7px, 5px);
    animation-timing-function: ease-in-out;
  }
  100% {
    transform: translate(2px, 2px);
  }
}

.info-background {
  background-color: $bg-dark;
}

.background {
  color: black;
  background: url("https://res.cloudinary.com/oredev/image/upload/v1662219405/cld-sample.jpg");
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
}
@media screen and (min-width: 1000px) {
  .background {
    min-height: 100vh;
  }
}

@media screen and (min-width: 1300px) {
  .background {
    min-height: 140vh;
  }
}
@media screen and (max-width: 500px) {
  .background {
    background-size: contain;
    background-position: top;
    background-repeat: no-repeat;
  }
}

.hero-headline {
  width: 100%;
  font-size: 3rem;
  text-transform: uppercase;
  font-family: "Rubik Glitch", cursive;
  color: #292929;
}

@media screen and (max-width: 900px) {
  .hero-headline {
    font-size: 30px;
  }
}
@media screen and (max-width: 500px) {
  .hero-headline {
    font-size: 24px;
  }
}

.buy-button {
  background: #292929 !important;
}

@media screen and (max-width: 1000px) {
  .buy-button.btn-1 {
    width: 80px !important;
  }
}

.buy-button:hover {
  background: $orange !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Workshops.vue